"use strict";module.exports=Number.MAX_SAFE_INTEGER||9007199254740991;